import { createReduxStore, register} from '@wordpress/data';
import reducer from './reducers';
import * as actions from './actions';
import * as selectors from './selectors';
import * as resolvers from './resolvers';
import controls from './controls';


const store = createReduxStore('lef-digitaal/wie-levert-wat', {
    reducer,
    actions,
    selectors,
    resolvers,
    controls
});

register(store);